import React, { useState } from "react";
import "./ProjectModal.css";

const ProjectModal = ({ project, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Prevent background scrolling when modal is open
  React.useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  if (!project) return null;

  const images = project.images || (project.image ? [project.image] : []);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="project-modal-overlay" onClick={onClose}>
      <div className="project-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="project-modal-close" onClick={onClose}>
          &times;
        </button>
        
        <div className="project-modal-body">
          <div className="project-modal-gallery-container">
          {images.map((img, index) => (
            <img
              key={index}
              src={img.startsWith('http') ? img : `/images/${img}`}
              alt={`${project.heading} screenshot preview ${index + 1}`}
              className={`project-modal-img ${index === currentImageIndex ? 'active' : ''}`}
            />
          ))}

            {images.length > 1 && (
              <>
                <button className="modal-slider-nav modal-slider-prev" onClick={prevImage} aria-label="Previous Image">
                  &#10094;
                </button>
                <button className="modal-slider-nav modal-slider-next" onClick={nextImage} aria-label="Next Image">
                  &#10095;
                </button>
                <div className="modal-slider-indicators">
                  {images.map((_, index) => (
                    <span 
                      key={index}
                      className={`modal-slider-dot ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={() => setCurrentImageIndex(index)}
                      aria-label={`Go to image ${index + 1}`}
                    ></span>
                  ))}
                </div>
              </>
            )}
          </div>
          
          <div className="project-modal-info">
            <div className="project-modal-title-wrapper">
              <div className="project-overline">Project Details</div>
              <h2>{project.heading}</h2>
            </div>
            
            <div className="project-modal-section">
              <p className="project-modal-description">{project.description}</p>
            </div>

            {project.tags && (
              <div className="project-modal-section">
                <h4 className="project-modal-subtitle">Technologies</h4>
                <div className="project-tags">
                  {project.tags.map((tag, i) => (
                    <span key={i} className="project-tag">{tag}</span>
                  ))}
                </div>
              </div>
            )}
            
            <div className="project-modal-section">
              <h4 className="project-modal-subtitle">Links</h4>
              <div className="project-modal-links">
                {project.live && (
                  <a href={project.live} target="_blank" rel="noopener noreferrer" className="project-modal-link">
                    View Live
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
                  </a>
                )}
                {project.source && (
                  <a href={project.source} target="_blank" rel="noopener noreferrer" className="project-modal-link">
                    Source Code
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
